import manifest from '../data/manifest.json';

const cache = { locations: {}, characters: {} };

export async function loadLocationDef(id) {
  if (!cache.locations[id]) {
    const mod = await import(`../data/locations/${id}.json`);
    cache.locations[id] = mod.default;
  }
  return cache.locations[id];
}

export async function loadCharacterDef(id) {
  if (!cache.characters[id]) {
    const mod = await import(`../data/characters/${id}.json`);
    cache.characters[id] = mod.default;
  }
  return cache.characters[id];
}

export function loadManifest() {
  return manifest;
}

export async function loadAllLocationDefs() {
  const ids = manifest.locations ?? [];
  const defs = await Promise.all(ids.map(id => loadLocationDef(id)));
  return Object.fromEntries(ids.map((id, i) => [id, defs[i]]));
}

export async function loadDefsForLocation(locationId, characterIds, generatedIds = new Set()) {
  const staticIds = characterIds.filter(id => !generatedIds.has(id));
  const [location, ...chars] = await Promise.all([
    loadLocationDef(locationId),
    ...staticIds.map(id => loadCharacterDef(id)),
  ]);
  const characters = Object.fromEntries(staticIds.map((id, i) => [id, chars[i]]));
  return { location, characters };
}
